import PluginTabs from './PluginTabs'

export default PluginTabs